type websocketUrlProps = (path: string) => string
const websocketUrlByPath: websocketUrlProps = path => {
  const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
  const port = window.location.port ? 8001 : ''
  return `${protocol}${import.meta.env.VITE_WEBSOCKET_BASE_URL}:${port}/ws/${path}`
}

export default websocketUrlByPath
